import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  AUTH_ERROR,
  UPDATE_PREF_FAILURE,
  UPDATE_PREF_REQUEST,
  UPDATE_PREF_SUCCESS,
  CLEAR_AUTH_ERROR,
  UPDATE_CURRENT_USER, // Nouvelle import
} from "./actionTypes"
import { REHYDRATE } from 'redux-persist' 

const initialState = {
  user: null,
  errorAuth: "",
  loadingAuth: false,
}

const Login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loadingAuth: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        user: action.payload.user,
        loadingAuth: false,
      }
      break
    case LOGOUT_USER:
      state = { ...state }
      break
    case LOGOUT_USER_SUCCESS:
      state = { ...state }
      break
    case AUTH_ERROR:
      state = { ...state, errorAuth: action.payload, loadingAuth: false }
      break
    case CLEAR_AUTH_ERROR:
      state = { 
        ...state, 
        errorAuth: "",
      }
      break
    case UPDATE_PREF_REQUEST:
      return {
        ...state,
        loadingAuth: true,
        errorAuth: null
      };
    case UPDATE_PREF_SUCCESS:
      return {
        user: {
          ...state.user,
          prefs: (action.payload?.prefs?.data?.prefs || state.user?.prefs || {}),
        },
        loadingAuth: false,
      };
    case UPDATE_PREF_FAILURE:
      return {
        ...state,
        loadingAuth: false,
        errorAuth: action.payload
      };
    case REHYDRATE:
      const incoming = action.payload ? (action.payload.Login || {}) : {};
      return {
        ...state,
        ...incoming,
        loadingAuth: false,
        errorAuth: "",
      };
    case UPDATE_CURRENT_USER:
      const updatedUser = Object.keys(state.user || {}).reduce((acc, key) => {
        acc[key] = action.payload.hasOwnProperty(key) ? action.payload[key] : state.user[key];
        return acc;
      }, {});
      
      return {
        ...state,
        user: updatedUser
      };
    default:
      state = { ...state }
      break
  }
  return state
}

export default Login